import { Vue, Component, Watch, Prop, Provide, Inject } from 'vue-property-decorator';
import style from './style.vue';
import { numberToArray } from '@/util';

@Component({
  components: {},
  mixins: [style],
})
export default class HotAd extends Vue {
  @Prop({ default: () => {} })
    value: ItemObject;

  @Prop()
    disabled;

  // 运营模式 1 镜单  2 镜千 3 云单 4 云千
  @Inject({ default: 0 })
    mode: number;

  @Prop({ default: false })
    classAd: boolean;

  data: ItemObject = {};

  carouselHeight = 0;

  @Watch('value', { deep: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
      if (this.mode === 2) {
        if (this.value.desc.list.length > 0) {
          if (this.classAd) {
            this.carouselHeight = (245 / this.value.desc.list[0].width) * this.value.desc.list[0].height;
          } else {
            this.carouselHeight = (320 / this.value.desc.list[0].width) * this.value.desc.list[0].height;
          }
        } else {
          this.carouselHeight = 150;
        }
      }
    }
  }

  mounted() {
    if (this.mode === 2) {
      if (this.value.desc.list.length > 0) {
        if (this.classAd) {
          this.carouselHeight = (245 / this.value.desc.list[0].width) * this.value.desc.list[0].height;
          return;
        }
        this.carouselHeight = (320 / this.value.desc.list[0].width) * this.value.desc.list[0].height;
      } else {
        if (this.classAd) {
          this.carouselHeight = 100;
          return;
        }
        this.carouselHeight = 150;
      }
    }
  }

  changeIndex(e) {
    // @ts-expect-error
    this.carouselHeight = this.$refs[`image${e}`].$el.clientHeight;
  }

  get maxNumber() {
    return numberToArray(this.value.desc.pMaxPage);
  }

  onActive() {
    this.$emit('click');
  }

  render(h) {
    const imgList = this.value.desc.list || [];
    // this.carouselHeight=(350 / this.value.desc.list[0].width) * this.value.desc.list[0].height
    return (
      <div>
        {this.mode == 2 && (
          <div
            class={{ 'hot-ad': true, 'is-actived': this.value.isActived || this.disabled }}
            style={
              this.classAd ? { background: '#f8f8f8', left: '-1px', height: `${this.value.desc.pHeight}px`, margin: '0 auto', pointerEvents: 'auto' } : { height: `${this.value.desc.pHeight}px`, margin: '0 auto', left: '0', pointerEvents: 'auto' }
            }
            onClick={this.onActive.bind(this)}>
            <el-carousel class="carousel" height={`${this.carouselHeight}px`} autoplay={false} onChange={this.changeIndex.bind(this)}>
              {imgList.map((val, i) => {
                return (
                  <el-carousel-item key={i}>
                    {val.advPic && <el-image class="carousel-img" ref={`image${i}`} src={val.advPic} />}
                    {this.classAd && (
                      <div class="mode-hotad-title-inner text-white" style="text-shadow: 0 0 12px rgba(0,0,0,.8)">
                        {val.advTitle}
                      </div>
                    )}
                  </el-carousel-item>
                );
              })}
            </el-carousel>
          </div>
        )}

        {this.mode == 1 && (
          <div class={{ 'hot-ad': true, 'is-actived': this.value.isActived || this.disabled }} style={{ height: `${this.value.desc.pHeight}px`, margin: '0 auto', left: '0', pointerEvents: 'auto' }} onClick={this.onActive.bind(this)}>
            <ul>
              {this.maxNumber.map(() => (
                <li />
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }
}
